
import { css } from '@emotion/react';

export function dashboardCSS() {
    return css`

        width: 100%;


        @media (max-width: 720px) {
            padding: 0;
        }

        .zoneCards{
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
            margin-bottom: 1.5rem;
            justify-content: stretch;
            align-items: stretch;
            justify-items: stretch;
        }

        @media (max-width: 1100px) {
            .zoneCards{
                grid-template-columns: repeat(2, 1fr);
            }
        }

        @media (max-width: 720px) {
            .zoneCards{
                grid-template-columns: 1fr;
            }
        }
            
        .message{
            width: 100%;
            margin: 0 auto;
            min-width: 200px;
            text-align: center;
            div{
                width: 60%;
                margin: 0 auto;
                min-width: 200px;
            }
        }

        /* Personaliza el color de fondo para filas impares */
        .custom-striped-table .p-datatable-tbody > tr:nth-child(odd) {
            background-color: #34b9e0; /* #34b9e0 con opacidad */
            color: white;
        }

        .custom-striped-table{
            border: 1px solid #b4c8f1 !important;
        }

        /* Centrar headers de la tabla */
        .custom-striped-table .p-datatable-thead > tr > th {
            font-weight: 520 !important;
            background-color: #f8f9fa !important;
            border-bottom: 2px solid #dee2e6 !important;
            padding: 1rem 0.5rem !important;
            .p-column-header-content{
                justify-content: center !important;
            }
            
        }

        /* Centrar contenido de las celdas del body */
        .custom-striped-table .p-datatable-tbody > tr > td {
            text-align: center !important;
            padding: 0.75rem 0.5rem !important;
        }

        /* Border radius para toda la tabla */
        .custom-striped-table {
            border-radius: 17px !important;
            overflow: hidden !important;
        }

        /* Border radius para el header de la tabla */
        .custom-striped-table .p-datatable-thead > tr:first-child > th:first-child {
            border-top-left-radius: 17px !important;
        }

        .custom-striped-table .p-datatable-thead > tr:first-child > th:last-child {
            border-top-right-radius: 17px !important;
        }

        

        // /* Opcional: cambia color al pasar el mouse */
        // .custom-striped-table .p-datatable-tbody > tr:hover {
        //     background-color:rgba(35, 181, 110, 0.47)
        // }

        .tables{
            width: 97%;
            display: flex;
            flex-wrap: wrap;
            gap: 2rem;
            margin: 0 auto;
            justify-content: space-between;
        }

        /* Estilos para el panel del dropdown de PrimeReact */
        .p-dropdown-panel {
            max-height: 500px !important;
            overflow-y: auto !important;
        }

        .p-dropdown-items {
            max-height: 480px !important;
        }

        .p-dropdown-item {
            padding: 0.75rem 1rem !important;
            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw) !important;
        }

        .p-dropdown-item:hover {
            background-color: rgba(52, 198, 241, 0.1) !important;
        }

        .p-dropdown-item.p-highlight {
            background-color: rgba(52, 198, 241, 0.2) !important;
        }

        @media (max-width: 768px) {
            .p-dropdown-item {
                font-size: calc(0.8rem + 1vw) !important;
            }
        }

        /* Estilos personalizados para el dropdown de selección de usuario */
        .Dropdown-user {
            
            .p-dropdown {
                border: 2px solid #34b9e0;
                border-radius: 12px;
                transition: all 0.3s ease;
            }

            .p-dropdown:hover {
                border-color: #23b56e;
                box-shadow: 0 4px 12px rgba(52, 185, 224, 0.3);
            }

            .p-dropdown:focus-within {
                border-color: #204B7B;
                box-shadow: 0 0 0 3px rgba(52, 185, 224, 0.2);
            }

            .p-dropdown-trigger {
                color: #34b9e0;
            }

            .p-dropdown-label {
                font-weight: 500;
                color: #495057;
            }
        }

      
        .p-component {
            border-radius: 17px !important;
            border: 1px solid #e0e0e0 !important;
        

            .p-card-body{
                border-radius: 17px !important;
                padding: 1rem !important;
            }
        }

     
       

       



    `;
}
